import React from 'react';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const ReportTechnicalDifficultiesMessage = ({ reloadRecording }) => {
  return (
    <div className="d-f fd-c">
      <div className="d-f ai-c">
        <Text className="pr-8" variant={TEXT_VARIANTS.INSTRUX_ERROR}>
          {t('questions.question.skipped.error')}
        </Text>
        <button type="button" className="u-linkBtn" onClick={reloadRecording}>
          <Text variant={TEXT_VARIANTS.BODY_LINK}>
            {t('questions.question.skipped.try_again')}
          </Text>
        </button>
      </div>
    </div>
  );
};

export default ReportTechnicalDifficultiesMessage;
